
import { TW_AppBlogArticle, TW_AppBlogArticleImage, TW_AppBlogParagraphMargin } from "@utils/twClasses";
import gestionUtilisateur from '@img/Gestion_utilisateur.png';
import pageGestionUtilisateur from '@img/Page_gestion_utilisateur.png';
import gestionMembresEspaceTravail2 from '@img/Gestion_membres_espace_travail_2.png';
import selectionRole from '@img/Selection_role.png';
import gestionRoles from '@img/Gestion_roles.png';
import accesDroitsVues from '@img/Acces_droits_vues.png';
import gestionDroitsVues from '@img/gestion_droits_vues.png';

export default function Page() {

    return (
        <div className={TW_AppBlogArticle}>
            <h1 className="mb-6 text-3xl font-semibold text-black">
                Les droits d'accès
            </h1>
            <p className={TW_AppBlogParagraphMargin}>
                Nous avons développé Compozz dans le but de créer un outil qui pourra être utilisé par tous les collaborateurs au sein de votre entreprise. Cela implique donc forcément une gestion des utilisateurs et des droits d’accès aux espaces de travail pointue, car tout le monde ne peut pas avoir accès à toutes les données.
            </p>
            <p className={TW_AppBlogParagraphMargin + " font-semibold + text-lg"}>
                Création d’un utilisateur
            </p>
            <p className={TW_AppBlogParagraphMargin}>
                Pour créer un utilisateur, vous devez être défini comme Administrateur du compte, sinon cette opération ne vous sera pas permise. Cliquez en haut à droite sur votre initiale, puis sur “Gestion des utilisateurs”.
            </p>
            <img src={gestionUtilisateur} alt="Accès à la gestion des utilisateurs" width={346} height={329} className={TW_AppBlogArticleImage} />
            <p className={TW_AppBlogParagraphMargin}>
                Cliquez ensuite sur “Ajouter un utilisateur” et remplissez les champs.
            </p>
            <p className={TW_AppBlogParagraphMargin}>
                Une fois l’utilisateur créé, vous pouvez choisir de le définir lui aussi comme administrateur du compte, il pourra lui aussi gérer les utilisateurs.
            </p>
            <p className={TW_AppBlogParagraphMargin}>
                Vous avez aussi la possibilité de désactiver un utilisateur, il ne comptera alors plus parmi le nombre d’utilisateurs autorisés pour le plan que vous avez choisi.
            </p>
            <img src={pageGestionUtilisateur} alt="Page de gestion des utilisateurs" width={1918} height={914} className={TW_AppBlogArticleImage} />
            <p className={TW_AppBlogParagraphMargin + " font-semibold + text-lg"}>
                Gestion des droits
            </p>
            <p className={TW_AppBlogParagraphMargin}>
                Vous pouvez ensuite gérer les droits des utilisateurs pour chaque espace de travail. Dans un espace de travail, rendez vous dans l’onglet “membres” en bas à gauche de votre écran. La liste des utilisateurs ayant déjà un rôle apparaît. Pour accéder à la liste complète des utilisateurs, cliquez sur "Tous les utilisateurs".
                <br />
                <br />
                Les administrateurs du compte ont par défaut tous les droits sur tous les espaces de travail. Pour les autres, ils n’en n’ont par défaut aucun. Vous allez devoir créer des rôles et les distribuer à chaque utilisateur ensuite.
                <br />
                <br />
                Un utilisateur qui n'a pas de rôle attribué est un utilisateur qui n'a pas accès à l'espace de travail. Il ne le verra même pas dans sa page d'accueil.
            </p>
            <img src={gestionMembresEspaceTravail2} alt="Page de gestion de tous les membres d'un espace de travail" width={1906} height={915} className={TW_AppBlogArticleImage} />
            <p className={TW_AppBlogParagraphMargin}>
                Cliquez sur “Gestion des rôles”, puis sur “Ajouter un rôle”, remplissez le champ puis sélectionnez-le dans la liste déroulante “Sélectionner un rôle”.
            </p>
            <img src={selectionRole} alt="Sélection d'un rôle pour modification des droits d'accès" width={1913} height={402} className={TW_AppBlogArticleImage} />
            <div className="flex gap-4 border-1 rounded-lg p-3 border-compozz-purple mt-10 mb-10 bg-white/20 ">
                <div className="">
                    <p className="mb-5 font-semibold text-compozz-purple">
                        Bon à savoir !
                    </p>
                    <p>
                        Avant d'aller plus loin, il est important de comprendre qu'il y a deux niveaux de droits : les droits sur le modèle de données et les droits sur la donnée.
                        Les droits sur le modèle de données sont les droits qui permettent de créer, modifier, supprimer des objets, des vues ou des tableaux de bord par exemple. Il s'agit de la définition des informations que vous allez gérer dans Compozz.
                        Les droits sur la donnée sont les droits qui permettent de lire, éditer, supprimer des enregistrements (lignes) dans un objet, une vue ou un tableau de bord par exemple. Il s'agit de l'information en elle-même.
                        <br />
                        <br />
                        Dans la suite de cette page, quand on parle d'objet, de vue ou de tableau de bord, il s'agit du modèle de données alors que quand on parle d'enregistrements ou de lignes, il s'agit de la donnée.
                    </p>
                </div>
            </div>
            <p className={TW_AppBlogParagraphMargin}>
                Dans la première catégorie “Autoriser l’accès”, vous pouvez définir les droits sur les objets de manière générale :
            </p>
            <ul className={TW_AppBlogParagraphMargin}>
                <li>
                    <span className="font-semibold">Accès complet :</span> l’utilisateur a tous les droits sur les objets (configuration comprise) et sur les enregistrements.
                </li>
                <li>
                    <span className="font-semibold">Accès en édition :</span> l’utilisateur peut modifier les enregistrements mais pas la configuration des objets.
                </li>
                <li>
                    <span className="font-semibold">Accès en lecture :</span> l’utilisateur a accès aux objets créés mais ne peut pas en créer de nouveau, ni modifier la configuration, ni éditer la donnée. Il peut seulement lire les enregistrements.
                </li>
                <li>
                    <span className="font-semibold">Accès refusé :</span> l’utilisateur n’a pas accès à l’objet, il n’apparaît pas dans sa session
                </li>
            </ul>
            <p className={TW_AppBlogParagraphMargin}>
                Sous le niveau d’accès, le menu “Options…” permet d’accorder des droits complémentaires sur les enregistrements, résumés par des pastilles :
            </p>
            <ul className={TW_AppBlogParagraphMargin}>
                <li>
                    <span className="font-semibold">Ajouter des enregistrements</span> et <span className="font-semibold">Supprimer des enregistrements :</span> disponibles à partir de l’accès en édition. Elles sont cochées par défaut quand vous passez un droit en édition ou en accès complet, et vous pouvez les décocher.
                </li>
                <li>
                    <span className="font-semibold">Exporter les données :</span> disponible à partir de l’accès en lecture. Elle n’est jamais cochée par défaut : l’export des enregistrements d’un objet est réservé aux propriétaires du compte tant qu’un administrateur ne l’accorde pas explicitement.
                </li>
            </ul>
            <p className={TW_AppBlogParagraphMargin}>
                Le même fonctionnement s’applique aux droits d’accès aux tableaux de bord, à l'exception de l'accès en édition qui n'existe pas dans ce cas.
            </p>
            <p className={TW_AppBlogParagraphMargin}>
                Pour les droits sur les membres, il n’y a que deux possibilités : soit l’utilisateur a le droit de modifier la liste des membres de l’espace de travail, de créer et de modifier des rôles, soit il ne l’a pas.
            </p>
            <p className={TW_AppBlogParagraphMargin}>
                Il en va de même pour les vues : soit l’utilisateur peut créer des vues, les modifier, les supprimer et les partager, soit il ne peut pas le faire. Dans le cas où l'utilisateur n'a pas les droits sur les vues, il ne pourra travailler que les vues qui lui ont été partagées.
            </p>
            <p className={TW_AppBlogParagraphMargin}>
                Dans la seconde catégorie “Droits sur les objets”, vous pouvez définir plus précisément les droits d’un utilisateur sur chaque objet. De cette manière, vous pouvez donner l’accès complet aux objets à un utilisateur, mais lui restreindre l’accès à un ou plusieurs objets en particulier. Ou inversement, vous pouvez interdire l'accès à l'ensemble des objets et autoriser ensuite l'accès uniquement à certains objets.
            </p>
            <div className="flex gap-4 border-1 rounded-lg p-3 border-compozz-purple mt-10 mb-10 bg-white/20 ">
                <div className="">
                    <p className="mb-5 font-semibold text-compozz-purple">
                        Bon à savoir !
                    </p>
                    <p>
                        La gestion des droits sur chaque objet prévaut sur la gestion des droits sur l'ensemble des objets. Ça signifie que si vous donnez l’accès complet à un objet à un utilisateur alors que vous lui avez refusé l’accès aux objets, il pourra voir cet objet et le modifier comme bon lui semble.
                    </p>
                </div>
            </div>
            <img src={gestionRoles} alt="Vue des droits accorder au rôle Collaborateur" width={1910} height={913} className={TW_AppBlogArticleImage} />
            <div className="flex gap-4 border-1 rounded-lg p-3 border-compozz-purple mt-10 mb-10 bg-white/20 ">
                <div className="">
                    <p className="mb-5 font-semibold text-compozz-purple">
                        Bon à savoir !
                    </p>
                    <p>
                        Il est également possible de décocher un droit d'accès. Cela permet de désactiver facilement un droit d'accès (pour tester par exemple) et de le réactiver plus tard.
                        Dans le cas des droits d'accès sur l'ensemble des objets, les tableaux de bord, les membres et les vues, cela est équivalent à configurer le droit d'accès à « Accès refusé ».
                        Dans le cas des droits d'accès sur chaque objet, cela est équivalent à restaurer la valeur par défaut, c'est-à-dire à appliquer le droit d'accès défini sur l'ensemble des objets.
                    </p>
                </div>
            </div>
            <p className={TW_AppBlogParagraphMargin + " font-semibold + text-lg"}>
                Gestion des droits sur les vues
            </p>
            <p className={TW_AppBlogParagraphMargin}>
                Lorsqu'un utilisateur crée une vue, cette vue est privée par défaut. Cela signifie que seul le créateur de la vue peut la voir et la modifier.
                Mais l'utilisateur peut partager la vue avec d'autres utilisateurs en définissant des droits d'accès sur la vue.
            </p>
            <p className={TW_AppBlogParagraphMargin}>
                Lorsque vous survolez une vue, 3 points s’affichent à droite, cliquez dessus puis sur “Partager la vue”.
            </p>
            <img src={accesDroitsVues} alt="Accès à la popup de gestion des droits pour les vues" width={919} height={332} className={TW_AppBlogArticleImage} />
            <p className={TW_AppBlogParagraphMargin}>
                Sélectionnez un rôle, puis l’accès que vous souhaitez lui accorder :
            </p>
            <ul className={TW_AppBlogParagraphMargin}>
                <li>
                    <span className="font-semibold">Accès complet :</span> les utilisateurs du rôle ont tous les droits sur la vue et sur la donnée, y compris la création et la suppression d’enregistrements.
                </li>
                <li>
                    <span className="font-semibold">Accès en édition :</span> les utilisateurs du rôle n'ont pas accès à la configuration de la vue mais peuvent créer, modifier et supprimer des enregistrements.
                </li>
                <li>
                    <span className="font-semibold">Accès en lecture :</span> les utilisateurs du rôle n'ont pas accès à la configuration de la vue mais peuvent lire la donnée.
                </li>
                <li>
                    <span className="font-semibold">Accès refusé :</span> les utilisateurs du rôle n'ont pas accès à la vue.
                </li>
            </ul>
            <img src={gestionDroitsVues} alt="Popup de gestion des droits pour les vues" width={745} height={433} className={TW_AppBlogArticleImage} />
            <p className={TW_AppBlogParagraphMargin}>
                Si vous ne définissez aucun droit, cette vue restera privée et ne sera accessible que par vous.
            </p>
            <p className={TW_AppBlogParagraphMargin}>
                Vous avez les clés en main pour paramétrer avec précision les droits d'accès de vos collaborateurs. Si des questions subsistent, n'hésitez pas à nous <a href="/freeTrial" className="text-compozz-darker-purple hover:underline">contacter</a> !
            </p>
        </div>
    )
}